import addressFormatter from '@fragaria/address-formatter';
import { RestApiAddressDto } from '@order-mage/integration-sdk';
import { Address, AddressInput } from '@/shared/model/Address';

export const formatAddress = (
    address: Address | AddressInput | RestApiAddressDto | Record<string, never> | null | undefined,
): string => {
    if (!address) {
        return '';
    }
    if (!address.city && !address.street && !address.postCode) {
        return '';
    }

    return addressFormatter
        .format(
            {
                city: address.city,
                countryCode: address.country,
                postcode: address.postCode,
                street: address.street,
            },
            {
                countryCode: address.country,
                appendCountry: false,
                abbreviate: true,
                output: 'array',
            },
        )
        .join(', ');
};
